import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import {SetProperties} from "@/models/SetProperties";

export class AchievementParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(Achievement.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    index >=0 && this.list.splice(index, 1, Achievement.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)))
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => Achievement.build(el))
    }
    return this
  }
}

export class Achievement extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.application = null
    this.name = null
    this.series = null
    this.number = null
    this.issueDate = null
    this.issueBy = null

    this.filesData = {}
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      name: this.name,
      series: this.series,
      number: this.number,
      issueDate: this.issueDate,
      issueBy: this.issueBy,
    }
  }

  static build(obj) {
    const _this = new Achievement()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.name = obj.name
      _this.series = obj.series
      _this.number = obj.number
      _this.issueDate = obj.issueDate
      _this.issueBy = obj.issueBy
    }
    return _this
  }
}
